import { useState, type FormEvent } from 'react';
import { Boton, Icono } from '../../ui';

interface PropsBuscador {
  alBuscar: (texto: string) => void;
  inicial?: string;
  placeholder?: string;
  tamano?: 'mediano' | 'grande';
  enfocar?: boolean;
}

/** La barra de "contanos qué te pasa". Es la misma en la portada, el inicio y la búsqueda. */
export function Buscador({
  alBuscar, inicial = '', placeholder = 'Contanos qué te pasa o qué especialista buscás', tamano = 'mediano', enfocar,
}: PropsBuscador) {
  const [texto, setTexto] = useState(inicial);
  const enviar = (e: FormEvent) => {
    e.preventDefault();
    alBuscar(texto.trim());
  };
  return (
    <form className="inicio__buscador" onSubmit={enviar} role="search">
      <Icono nombre="search" tamano={20} />
      <input aria-label="Qué te pasa o qué especialista buscás" placeholder={placeholder} value={texto} maxLength={120}
        autoFocus={enfocar} onChange={(e) => setTexto(e.target.value)} />
      <Boton type="submit" tamano={tamano}>Buscar</Boton>
    </form>
  );
}

export const rutaDeBusqueda = (texto: string) => (texto ? `/buscar?texto=${encodeURIComponent(texto)}` : '/buscar');
